import { PrecompraService } from "src/app/services/precompra.service";


import { ModulomxService } from "./../../services/modulomx.service";
import { EntransitoService } from "./../../services/entransito.service";
import { MovimientospgosService } from "./../../services/movimientospgos.service";

import { Usuario } from "./../../models/usuario";

import { UsuarioService } from "./../../services/usuario/usuario.service";
import { TablasolicitanteService } from "./../../services/tablasolicitante/tablasolicitante.service";

import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { Solicitante } from "./../../models/solictante";
import { Pescador } from "./../../models/pescador";

import { TablapescadoresService } from "src/app/services/tablapescador/tablapescadores.service";
import { FormGroup, FormControl } from "@angular/forms";
import { SubirarchivoService } from "./../../services/subirarchivo/subirarchivo.service";
import { FileService } from "src/app/services/file.service";
import { saveAs } from "file-saver";
import { SolicitanteService } from "../../services/solicitante/solicitante.service";
import Swal from "sweetalert2";
import { EmailService } from "src/app/services/email/email.service";
import * as moment from "moment";
import { Router } from "@angular/router";

import { MatDialog } from "@angular/material";
import { CapturaComponent } from "../usuario/captura/captura.component";


import { NgxSpinnerService } from "ngx-spinner";
import { NotificationsService } from "angular2-notifications";
import { SocketioService } from "src/app/services/socketio.service";
import { Colorenglon } from "src/app/models/color";
import { Lote } from "src/app/models/lote";
import { LoteService } from "src/app/services/lote.service";


import { BotadmonService } from "src/app/services/botadmon.service";
import { Botadmin } from "src/app/models/botadmin";



@Component({
  selector: 'app-botadmin',
  templateUrl: './botadmin.component.html',
  styleUrls: ['./botadmin.component.css']
})
export class BotadminComponent implements OnInit {
  listadolote: Lote[] = [];
  botadminInfo: Botadmin;
  listalotemodificacion: Lote;
  listasolicitantes: Solicitante[];
  listaPescadores: Pescador[];
  idsolicitante = "";
  claveusuario: string;
  solicitudhtml = "";
  entransito = 0;
  enviados: number;
  successMessage: any;
  titulosuccessMessage: "";
  contadorsolicitudes = 0;
  filtroPost = "";
  colorpersonal = "";
  bprecompra = false;
  cveclientesolicitante = "";
  numeropaypal = "";
  nombrearchivoxls = "";
  botonrefreshtexto = "";
  usuariolistado: Usuario[] = [];
  nombrebot = "";
  txtstatusmovimiento = "En espera";
  refrescaSolicitudes = false;

  licdevueltas = 0;
  cveunicasmx = "";


  registrovienede = "";

  rotulabotonLicencia = "Archivo Adjunto: Ninguno";
  rotulabotonLicenciaexp = "Subir Licencia-Exp";

  minutos: number = 0;
  segundos: number = 0;
  colorCheck = false;

  // esta variable rotula el bootn de subur licencias

  // botonFinalizadeshabilitado = false;
  // const locale = 'en-US';

  txtSolicitante: string;
  txtemail: string;
  txtOrdenSolicitud: string;
  txtcantidaSolicitada: string;
  txtsolicitado: number;
  txttotalPagado: any;
  grantotalusuario: number;
  archivoSubir: File;

  isDivVisible: boolean;

  extensionArchivo: string;
  nombreArchivo: string;

  showExcel: boolean;
  showEmail: boolean;
  idusuarioActivo: string; // esta variable contiene el id del usuario actual
  showPDF: boolean;
  idsolicitudActual: string; // esta variable contine le id ddel la "solicitud" actual
  procederCaptura: boolean; // esta variable es la bandera para colorear los renglones de procesar la inforamcion semafor verde y rojo
  nombreArchivoPDF: string;
  subjettxt: string;
  cantidadpagada: number;
  solicitantetxt: string;
  apellidos: string;
  idempresa: string;

  ciudadsolicitante: string;
  tipoLicenciatxt: string;
  estadotxt: string;
  fechasolicitudtxt: string;

  cambiacolorcuadro = "gris";
  cambiacolordisponiblilidad = "gris";

  formaLectura: FormGroup;
  inventario = 0;
  disponibilidad = 0;
  idultimoinventario: string;
  mysmsg: any;
  statusbots: string;

  lisennumerofolio: string;
  lisencolor: string;
  precomprasrealizadas = 0;
  es_usuariosportmx = false;
  variableusuario = "";
  numeroidusuariomx = "";
  identificadorpescador: string;
  sususuarios: any;
  sus_botadmin: any;
  aliasusuario: string;
  @ViewChild("bots", { static: true }) bots: ElementRef;

  // @ViewChild('solicitantetxt', { static: true }) solicitantetxt: ElementRef;
  // @ViewChild('ciudadsolicitante', { static: true }) ciudadsolicitante: ElementRef;
  // @ViewChild('tipoLicenciatxt', { static: true }) tipoLicenciatxt: ElementRef;
  // @ViewChild('apellidos', { static: true }) apellidos: ElementRef;

  // @ViewChild('estadotxt', { static: true }) estadotxt: ElementRef;
  // @ViewChild('fechasolicitudtxt', { static: true }) fechasolicitudtxt: ElementRef;


  constructor(
    public tablaSolicitanteService: TablasolicitanteService,
    public tablaPescadoresService: TablapescadoresService,
    private subirArchivoService: SubirarchivoService,
    private solicitanteService: SolicitanteService,
    private _fileService: FileService,
    private emailService: EmailService,
    private usuarioservice: UsuarioService,
    public router: Router,
    private dialog: MatDialog,
    private socketService: SocketioService,
    private precompraService: PrecompraService,
    private movimientopgoService: MovimientospgosService,
    private entransitoService: EntransitoService,
    private spinner: NgxSpinnerService,
    public modulomxService: ModulomxService,
    private notificationsService: NotificationsService,
    private loteService: LoteService,
    private _botadmin: BotadmonService


  ) {



  }

  ngOnInit() {
    this.start();

    this.botonrefreshtexto = "Refrescar";
    this.variableusuario = localStorage.getItem("userol");

    if (this.variableusuario === "USER_SPORTFISHING") {
      this.es_usuariosportmx = true;
    }

    this.numeroidusuariomx = localStorage.getItem("iduser");

    this.statusbots = "Bots";

    this.socketService.listen("solicitalicencia").subscribe((data) => {
      const jsonstring = JSON.stringify(data);
      const obj = JSON.parse(jsonstring);

      this.titulosuccessMessage = obj.de;
      this.successMessage = obj.cuerpo;
      this.Notificacion(this.titulosuccessMessage, this.successMessage);
      this.playAudio();
    });

    this.socketService.listen("colorearenglon").subscribe((data) => {
      const jsonstring = JSON.stringify(data);
      const obj = JSON.parse(jsonstring);

      this.lisencolor = obj.color;
      this.lisennumerofolio = obj.numerofolio;
      this.colorearenglon(this.lisennumerofolio, this.lisencolor);
    });


    // cambia le color dle boton cuando alguna instancia del mismo objeto presiona kel boton de conectar botsdmin
    // ************************************************************************************************************
    this.socketService.listen("botadminconnectado").subscribe((data) => {
      const jsonstring = JSON.stringify(data);
      const obj = JSON.parse(jsonstring);
      this.colorCheck = obj.connectado;
    });
    // ****************************************************************************
    // *******************************************************************************

    this.idultimoinventario = "";
    this.isDivVisible = true;
    this.aliasusuario = this.usuarioservice.alias;
    // this.socketService.setupSocketConnection();
    this.muestrasolicitantesquepagaron(this.aliasusuario);
    // this.getMessages().subscribe ( msg => {

    //       this.muestrasolicitantesquepagaron();
    //     });

    this.txtSolicitante = "";
    this.txtemail = "Correo electronico de la Empresa";
    this.txtOrdenSolicitud = "";
    this.nombreArchivo = "";
    this.showExcel = false;
    this.showPDF = false;
    this.showEmail = false;
    this.subjettxt = "";
    this.enviados = 0;

    this.idusuarioActivo = localStorage.getItem("id");
    this.colorpersonal = this.usuarioservice.colorpersonal;
    this.idempresa = this.usuarioservice.idempresa;

    //this.botadminconnect();
    // este opcin cambia le color del boton cuando le administrador ha sido presionado
    this.cambiastatusbotadmin();
    // *********************

    // this.listandobotsinicialmente();
  }

  ngOnDestroy() {
    // this.sususuarios.unsubscribe();
  }



  
  botadminpress() {
    let opcionSeleccion: boolean = true;

    //this.botadminInfo.idusuario="123";
    if (this.colorCheck) {
      opcionSeleccion = false;
    } else {
      opcionSeleccion = true;
    }
    const botadmiNuevodatos = new Botadmin(
      "62905b6a0be24b74fc16f15f",
      opcionSeleccion
    );

    this._botadmin.statusbotAdmin(botadmiNuevodatos, "62905b6a0be24b74fc16f15f")
      .subscribe(resp => {
        this.colorCheck = opcionSeleccion;
        this.botadminconnect(opcionSeleccion);
      })
  }

  refrecarBots() {
    this.Listadousuarios();
  }


  botadminconnect(status: boolean) {
    const payload = {
      connectado: status,
    };
    this.socketService.emit("botadminconnectado", payload);
  }



  devuelvelicencias(
    numero_orden: string,
    cantidalicencias: string,
    idsmx: string,
    texto: string,
    identificadorpescador: string
  ) {
    this.movimientopgoService
      .devolucioneslicencias(
        numero_orden,
        cantidalicencias,
        idsmx,
        texto,
        identificadorpescador
        
      )
      .subscribe((respuesta) => {
        console.log(respuesta);
      });
  }


  start() {
    setInterval(() => {
      this.segundos += 1;
      if (this.segundos == 60) {
        this.segundos = 0;
        this.minutos += 1;
      }
    }, 1000);
  }

  async Listadousuarios() {
    this.sususuarios = await this.usuarioservice
      .listadototalusuariosxempresa(this.idempresa)
      .subscribe((resp) => {
        let prom2 = new Promise<void>((resolve) => {
          this.usuariolistado = resp;
          setTimeout(() => {
            resolve();
          }, 1500);
        });

        prom2.then(() => {
         // alert("recarga de bots");
        });
      });
  }

  async listandobotsinicialmente() {
    this.sususuarios = await this.usuarioservice
      .listadototalusuariosxempresa(this.idempresa)
      .subscribe((resp) => {
        this.usuariolistado = resp;
      });
  }


  cambiastatusbotadmin() {
    this._botadmin.getstatusBotAdmin()
      .subscribe((resp) => {
        const jsonstring = JSON.stringify(resp);
        const obj = JSON.parse(jsonstring);

        if (obj.botadminEncontrado.activado) {
          this.colorCheck = true;
        } else {
          this.colorCheck = false;
        }



      });
  }

  playAudio() {
    const audio = new Audio();
    audio.src = "../../../assets/sound/notification.mp3";
    audio.load();
    audio.play();
  }

  escuchasocket() { }

  usermxapagado(listado: Usuario) {
    let nombrebot = listado.alias;
    this.usuariolistado.find((item) => { });
  }

  disponibilidadlotes() {
    // la idea es accesar al primer registro unicamente para conocer el valor
  }

  asignarlote(usuario: Usuario) {
    // this.spinner.show();
    // this.statusbots = "Esperando..."

    // let cuentalinealote = 1
    // for (let numero of this.listadolote){
    //   if (cuentalinealote = 1) {
    //     this.listadolote[0].
    //   } else {
    //     if (cuentalinealote = 2) {

    //       return;
    //     }
    //   }

    //   console.log(numero);
    // }

    //  let lotesdisponiblesEmpresas = this.listadolote.length;


    //   let valordescripcion = this.txtcantidaSolicitada; // este vlor lo toma de los cuadros de la tabla -descripcion solicitus-
    //   let posicionprimercaracter = valordescripcion.indexOf("-");  // de ese valor busca el guion para poder separa el numero dle texto
    //   let valornumericodisponible = (this.listadolote[0].disponible) - Number(
    //     valordescripcion.slice(0, posicionprimercaracter)
    //   );  // y con este procedimienot resta la disponibilidad actual con la cantidad solicitada de manera anticipada
    //   let idlotes = this.listadolote[0]._id;


    // if (valornumericodisponible >= 0) {
    this.asignausuariosylotesbotadmin(usuario.alias, usuario._id);

    //   } else {
    //    if (valornumericodisponible < 0){
    //     if (this.listadolote[0].status){ // este queire decir que esta ocupado haciendo le proceso y como no cabe debera pasar al siguiente lote
    //      console.log ('no disponible');

    //} else {

    //   console.log ('disponible');
    //   this.asignausuariosylotesbotadmin(usuario.alias, usuario._id,valornumericodisponible, idlotes);




    //  }

    //   }
    //  }

  }


  asignausuariosylotesbotadmin(aliasusuario: string, identificadorusuario) {
    this.nombrebot = aliasusuario;
    this.usuarioservice
      .actualizastatusbotadmin(identificadorusuario, "busy", this.txtOrdenSolicitud)
      .subscribe((resp) => {
        let prom1 = new Promise<void>((resolve) => {
          this.usuariolistado = resp.usuario;
          this.listasolicitantes = resp.solicitante;

          console.log(this.listadolote);


          this.statusbots = "Bots";
          this.enviarnotificaciondecompra(
            "BotAdmin, asigno trabajo a " + this.nombrebot
          );
          // this.spinner.hide();
          setTimeout(() => {
            resolve();
          }, 1500);
        });

        prom1.then(() => {
          this.muestralotedempresa(this.idempresa);
          alert('Asignacion Correcta');


        });

        // this.modulomxService.mensajeadquierelicencias(this.idempresa, 'compralicencias');
      });
  }

  enviarnotificaciondecompra(mensaje: string) {
    // socket envia accion
    this.modulomxService.mensajesolicitudlicencias("adminBot", mensaje);
  }


  cambiastatusbot(info: Usuario, status) {
    if (info.status == "off") {
      status = "On"
    } else {
      if (info.status == "free") {
        status = "off"
      } else {
        status = "off"
      }
    }
    this.usuarioservice
      .cambiastatus(info._id, status)
      .subscribe((resp) => {
        this.usuariolistado = resp.usuario;

        // this.modulomxService.mensajeadquierelicencias(this.idempresa, 'compralicencias');
      });

  }

  tareafinalizada(cveus: string, status) {
    if (status == "off") {
      status = "On";
    }

    this.usuarioservice
      .actualizastatustarea(cveus, status)
      .subscribe((resp) => {
        this.usuariolistado = resp.usuario;

        // this.modulomxService.mensajeadquierelicencias(this.idempresa, 'compralicencias');
      });
  }

  // 982 1242016

  // edgar

  muestrasolicitantesquepagaron(usuarioinicial: string) {
    this.txtstatusmovimiento = "En espera";

    this.spinner.show();

    let promesa = new Promise<void>((resolve, reject) => {
      setTimeout(() => {
        this.tablaSolicitanteService.getLicencias(usuarioinicial).subscribe(
          (listado) => {
            this.listasolicitantes = listado;
          },
          (err) => console.log(err)
        );

        resolve();
      }, 100);
    });

    promesa.then(
      () => {
        this.spinner.hide();
        // this.txtstatusmovimiento = "Listo";
        this.refrecarBots();
        alert("Informacion Desplegada");

      },
      (error) => {
        this.spinner.hide();
        console.error("onRejected function called: " + error.message);
      }
    );
  }

  despliegalistado(listado: Solicitante) {
    alert("hola");
  }

  muestraPescadoreslista(listado: Solicitante) {
    this.spinner.show();
    this.txtstatusmovimiento = "Procesando...";

    let promesa = new Promise<void>((resolve, reject) => {
      setTimeout(() => {
        this.idsolicitudActual = listado._id;
        this.idsolicitante = listado.idusuario;

        // alert (this.idultimoinventario );

        this.txtSolicitante = listado.nombre;

        // console.log (this.txtSolicitante );
        this.txtemail = listado.email;

        this.txtOrdenSolicitud = listado.numeroperacion;
        this.nombreArchivo = listado.nombrearchivo;
        this.nombreArchivoPDF = listado.nombrearchivopdf;
        this.subjettxt = listado.nombrearchivopdf;
        this.solicitudhtml = listado.solicitudhtml;
        this.registrovienede = listado.vienedemodulo;
        this.nombrearchivoxls = listado.nombrearchivo;
        this.cveunicasmx = listado.cveusermx;

        this.txtcantidaSolicitada = "";
        this.txtsolicitado = 0;
        this.txttotalPagado = "";

        console.log("nombre archivo", this.solicitudhtml);
        this.showPDF = false;
        this.showExcel = false;

        //    if ( this.nombreArchivo === 'null' || this.nombreArchivo === 'undefined' || this.nombreArchivo === 'null') {
        // this.showExcel = false;
        //   } else {
        // this.showExcel = true;
        //   }

        console.log(this.solicitudhtml);

        if (this.solicitudhtml === undefined || this.solicitudhtml === null) {
          this.showExcel = false;
        } else {
          this.showExcel = true;
        }

        // console.log ('nombre pdf pfd' + this.nombreArchivoPDF );
        if (
          this.nombreArchivoPDF === "null" ||
          this.nombreArchivoPDF === "undefined" ||
          this.nombreArchivoPDF === "No Generado"
        ) {
          this.showPDF = false;
        } else {
          this.showPDF = true;
        }

        if (
          this.nombreArchivo === "null" ||
          this.nombreArchivo === "undefined" ||
          this.nombreArchivo === "No Generado"
        ) {
          this.showExcel = false;
        } else {
          this.showExcel = true;
        }

        // this.colorearenglon(listado.numeroperacion,'#C71585');

        this.tablaPescadoresService.getpescadores(listado._id).subscribe(
          (listadoPescadores) => {
            this.listaPescadores = listadoPescadores;

            this.muestradatosPescadores(this.listaPescadores[0]);

            if (this.txtcantidaSolicitada.includes("Dia")) {
              this.muestralotedempresa(listado.idempresa);
            } else {
              if (this.txtcantidaSolicitada != "") {
                this.muestralotedempresavarios(this.txtcantidaSolicitada);
              }
            }
          },
          (err) => console.log(err)
        );

        if (listado.deprecompra) {
          this.bprecompra = true;
          this.isDivVisible = false;
          this.ultimaprecompra(listado.idempresa);
          this.licenciaentransito(listado.idempresa);
        } else {
          this.bprecompra = false;
          this.isDivVisible = true;
        }

        resolve();
      }, 100);
    });

    promesa.then(
      () => {
        this.spinner.hide();
        this.txtstatusmovimiento = "Listo";
        // alert ("datos completados")
      },
      (error) => {
        this.spinner.hide();
        console.error("onRejected function called: " + error.message);
      }
    );
  }

  deshabilitarlote() { }

  checainventariosprecompras() { }

  rectificapropiedadvalor(posicion: string, color: string) {
    // alert (posicion);
    let element = document.getElementById(posicion);
    return true;

    // if ( element.style.backgroundColor === '') {
    //   return true;
    // } else {
    //   if (element.style.backgroundColor !== color ){
    //     alert ('es otro usuario');
    //     return false;
    //   }

    // }
  }

  colorearenglon(posicion: string, color: string) {
    // alert (posicion);
    let element = document.getElementById(posicion);
    element.style.backgroundColor = color;
  }

  muestradatosPescadores(listadopescadores: Pescador) {
    this.solicitantetxt = listadopescadores.nombre;
    this.txtcantidaSolicitada = listadopescadores.tipolicencia;
    this.txtsolicitado = listadopescadores.cantidad;
    this.apellidos = listadopescadores.apellido;
    this.txttotalPagado = listadopescadores.costolicencia;
    this.identificadorpescador = listadopescadores._id;

    this.ciudadsolicitante = listadopescadores.ciudad;
    this.tipoLicenciatxt = listadopescadores.tipolicencia;
    this.estadotxt = listadopescadores.estado;
    this.licdevueltas = listadopescadores.licdevueltas;

    if (this.licdevueltas > 0) {
      this.colorCheck = true;
    } else {
      this.colorCheck = false;
    }

    // this.cantidadpagada = listadopescadores.costolicencia;
    // this.txttotalPagado = listadopescadores.costolicencia;
    // this.fechasolicitudtxt.nativeElement.value = moment(listadopescadores.fechainiciopesca).format('DD-MM-YYYY') ;

    const d = new Date(listadopescadores.fechainiciopesca);
    d.setMinutes(d.getMinutes() + d.getTimezoneOffset());

    this.fechasolicitudtxt = moment(d).format("DD-MMM-YYYY");
  }

  SeleccionImagen(event) {
    //  alert ("archivo seleccionado");
    const file = event.target.files[0];

    this.archivoSubir = file;
    const id = "archivo";
    // const id = this.nombrearchivoCreado;
    const vnombreArchivofile = file.name;

    const extensionfile = vnombreArchivofile.indexOf("pdf");
    console.log(extensionfile);

    if (extensionfile === 0) {
      this.extensionArchivo = "pdf";
    } else {
      this.extensionArchivo = "pdf";
    }

    //  var nombreArchivoSeleccionado = string(this.archivoSubir;

    this.subjettxt = vnombreArchivofile;
    this.rotulabotonLicencia = vnombreArchivofile;
    console.log("nombre dle nuevo archivo", this.rotulabotonLicencia);

    this.subirArchivoService
      .subirArchivo(this.archivoSubir, "download", id)
      .then((resp) => {
        console.log("respuesta arcchivo", resp);

        this.showPDF = true;
        //   console.log ('mensaje de archivo2 ', vnombreArchivofile);
        this.nombreArchivoPDF = vnombreArchivofile;

        this.actualizaPDF(vnombreArchivofile);
      })
      .catch((resp) => {
        console.log("esta es una rexteespuesta", resp);
      });
  }

  Notificacion(titulo, message) {
    this.contadorsolicitudes = this.contadorsolicitudes + 1;
    this.notificationsService.success(titulo, message, {
      position: ["botton", "right"],
      timeOut: 5000,
      animate: "fade",
      showProgressBar: true,
    });
  }

  download() {
    const filename = this.nombreArchivo;
    console.log("nombre dle archivo filename", filename);

    this._fileService.downloadFileExcel(filename).subscribe(
      (data) => saveAs(data, filename),
      (error) => console.error(error)
    );

    //    const dialogRef = this.dialog.open(EditorComponent, { width:'1500px', disableClose: true,
    //    data: {
    //      identificador: this.solicitudhtml
    //    }
    //  });

    //            dialogRef.afterClosed().subscribe(
    //             data => this.solicitudhtml = data
    //         );
  }

  downloadpdf() {
    const filename = this.nombreArchivoPDF;

    this._fileService.downloadFilePDF(filename).subscribe(
      (data) => saveAs(data, filename),
      (error) => console.error(error)
    );

    //    const dialogRef = this.dialog.open(EditorComponent, { width:'1500px', disableClose: true,
    //    data: {
    //      identificador: this.solicitudhtml
    //    }
    //  });

    //            dialogRef.afterClosed().subscribe(
    //             data => this.solicitudhtml = data
    //         );
  }

  finalizarProceso() {
    //  if (this.showPDF) {
    this.solicitanteService
      .solicitudFinalizada(this.idsolicitudActual)
      .subscribe((res) => {
        this.txtOrdenSolicitud = "";
        this.txtSolicitante = "";
        this.txtemail = "";
        this.showExcel = false;
        this.showPDF = false;

        this.muestrasolicitantesquepagaron(this.aliasusuario);
      });

    //  } else {
    //   Swal.fire('Oops...', 'Creo que olvido subir el archivo', 'error');
    //  }
  }

  actualizaPDF(nombrearchivo) {
    this.solicitanteService
      .actulizanombreArchivoSolicitante(this.idsolicitudActual, nombrearchivo)
      .subscribe((res) => {
        this.muestrasolicitantesquepagaron(this.aliasusuario);
      });
  }

  elijecliente(listado: Solicitante) {
    this.idusuarioActivo = localStorage.getItem("id");

    this.tablaPescadoresService
      .eleccionRealizadaCliente(listado._id, this.idusuarioActivo)
      .subscribe(
        (seleccionado) => {
          this.procederCaptura = seleccionado;
        },
        (err) => console.log(err)
      );
  }

  visualizaCliente() {
    //  console.log (this.idsolicitante);
    this.editarusuarios(this.idsolicitante);
  }

  devolucionpermisos() {
    let promesadevolucion = new Promise<void>((resolve, reject) => {
      setTimeout(() => {
        if (this.txtOrdenSolicitud != "") {
          //  const session = await
        }

        const nombreArchivocompleto = this.nombreArchivoPDF;
        const subJet = this.subjettxt;
        this.spinner.show();
        const direccionemail = this.txtemail;
        const filepdf = nombreArchivocompleto;
        this.nombreArchivoPDF = filepdf;
        this.emailService
          .sendEmail(direccionemail, filepdf, subJet)
          .subscribe((licen) => {
            this.colorearenglon(this.txtOrdenSolicitud, "#FF4500");

            this.encuentrayactualizapescadoremail(this.idsolicitudActual);

            if (this.bprecompra) {
              this.entransitoService
                .borra(this.txtOrdenSolicitud)
                .subscribe((archivoborrado) => {
                  this.licenciaentransito(this.idempresa);
                  // aqui llmaremos el emit
                  const payload = {
                    para: this.txtOrdenSolicitud,
                    archivopdf: this.nombreArchivoPDF,
                  };
                  this.socketService.emit("muestrapdf", payload);
                  // actualziaremos ahora a true en pescadores que ya fue enviado
                  // this.encuentrayactualizapescadoremail(this.idsolicitudActual);
                });
            }

            //  this.refrescaInfoSolicitante();
            this.botonrefreshtexto = "Actualiza";

            // this.txtOrdenSolicitud
            // this.botonFinalizadeshabilitado = false;

            // se presionar le boton de refrescar para desaparecer la linea terminada

            //  setTimeout(function(){

            //     },3000);
          });

        resolve();
      }, 1000);
    });

    promesadevolucion.then(
      () => {
        console.log("terminado");
      },
      (error) => {
        console.error("onRejected function called: " + error.message);
      }
    );
  }

  encuentrayactualizapescadoremail(identificador: string) {
    this.txtstatusmovimiento = "Procesando...";

    let promesa = new Promise<void>((resolve, reject) => {
      setTimeout(() => {
        this.tablaPescadoresService
          .actualizemail(identificador)
          .subscribe((emailactualizado) => {
            console.log(emailactualizado);
            /** spinner ends after 5 seconds */
            this.listasolicitantes.map((dato) => {
              if (dato.numeroperacion === this.txtOrdenSolicitud) {
                dato.enviadoporemail = true;
              }
            });
          });
        resolve();
      }, 1000);
    });

    promesa.then(
      () => {
        this.spinner.hide();
        this.txtstatusmovimiento = "Listo";
      },
      (error) => {
        this.spinner.hide();
        console.error("onRejected function called: " + error.message);
      }
    );
  }

   refrescaInfoSolicitante() {
    this.contadorsolicitudes = 0;
    this.botonrefreshtexto = "Refrescar";
     this.muestrasolicitantesquepagaron( this.aliasusuario);
  }

  limpiarcomponentes() { }

  editarusuarios(idsolicitante: string) {
    this.usuarioservice
      .LocalizaInfoUsuarios(idsolicitante)
      .subscribe((resp) => {
        this.dialog.open(CapturaComponent, {
          panelClass: "mensaje",
          disableClose: true,
          data: {
            identificador: resp,
          },
        });
      });
  }

  // getMessages() {
  //   return this.wsService.listen('mensaje-nuevo');
  // }

  ultimaprecompra(idempresa: string) {
    console.log("id empresa", idempresa);
    this.precompraService
      .buscaultimaprecompra(idempresa)
      .subscribe((ultimo) => {
        if (ultimo.precompra.length === 0) {
        }
        this.idultimoinventario = ultimo.precompra[0]._id;
        this.inventario = ultimo.precompra[0].inventariototal;
        this.disponibilidad = ultimo.precompra[0].disponibilidad;
        this.muestrainventario(this.idultimoinventario);
        this.numeropaypal = ultimo.precompra[0].refenciapaypal;

        // if (ultimo.pescador[0].idinventarios === ultimo.precompra[0]._id) {
        //   this.cambiacolorcuadro = 'verde';
        // }

        this.precomprasrealizadas = ultimo.solicitudesencontradas.reduce(
          (acc, obj) => acc + obj.cantidad,
          0
        );

        const disponible = this.inventario - this.precomprasrealizadas;

        if (disponible === this.disponibilidad) {
          this.cambiacolordisponiblilidad = "verde";
        }
      });
  }

  muestrainventario(idinventario: string) {
    this.tablaPescadoresService
      .getpescadorinventario(idinventario)
      .subscribe((resp: any) => {
        this.enviados = resp.pescador.reduce(
          (acc, obj) => acc + obj.cantidad,
          0
        );
      });
  }

  licenciaentransito(idempresa: string) {
    this.movimientopgoService.listaentransito(idempresa).subscribe((resp) => {
      // this.entransito = resp.entransitomovimiento;
      console.log(resp);
      this.entransito = resp.entransitomovimiento.reduce(
        (acc, obj) => acc + obj.cantidad,
        0
      );
    });
  }

  // guardacambioslotes(listadolotes: Lote) {
  //   this.listalotemodificacion = listadolotes;

  //   console.log(this.listalotemodificacion);
  // }













  seleccionarenglon(listado: Solicitante) {
    const colorrenglon = new Colorenglon(this.colorpersonal);

    this.solicitanteService
      .cambiacolorrenglonsolicitante(listado._id, colorrenglon)
      .subscribe((resp) => {
        const payload = {
          color: this.colorpersonal,
          numerofolio: listado.numeroperacion,
        };

        let valoraceptado = this.rectificapropiedadvalor(
          listado.numeroperacion,
          this.colorpersonal
        );
        if (valoraceptado) {
          this.socketService.emit("colorearenglon", payload);
        }
      });
  }

  async muestralotedempresa(idempresa: string) {
    this.loteService.muestraloteempresa(idempresa).subscribe((resp) => {
      this.listadolote = resp.lote;
    });
  }

  muestralotedempresavarios(tipoempresa: string) {
    if (this.txtcantidaSolicitada.includes("Excursion")) {
      tipoempresa = "Excursion";
    } else {
      if (this.txtcantidaSolicitada.includes("Año")) {
        tipoempresa = "año";
      } else {
        tipoempresa = "semana";
      }
    }

    this.loteService.muestraloteempresavarios(tipoempresa).subscribe((resp) => {
      console.log("********************" + resp.lote)
      this.listadolote = resp.lote;
    });
  }
}

